
import { INPUT_TYPE } from "../../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../../SequenceNumberFormat/Other";


export const MY_TAX_DETAILS_FORM = [
    {
        key:"registrationNumber",
        columnCode: "registrationNumber",
        options:[],
        icon:"",
        validation:{
            range:{                
            maxLength: 20
            }
        },
        isValid:true,
        name:"Company Registration Number",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    
    {
        key:"empTaxNumber",
        columnCode: "empTaxNumber",
        options:[],
        icon:"",
        validation:{
            range:{                
            maxLength: 10
            }
        },
        isValid:true,
        name:"Employer Tax Number",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"companyTaxNumber",
        columnCode: "companyTaxNumber",
        options:[],
        icon:"",
        validation:{
            regExp :'(^[[a-zA-Z]{1,2})([0-9]{0,10}$)',
            
        },
        isValid:true,
        name:"Company Tax Number",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"socsoNumber",
        columnCode: "socsoNumber",
        options:[],
        icon:"",
        validation:{
            regExp :'(^[[a-zA-Z]{1})([0-9]{10}[a-zA-Z]{1}$)',
        },
        isValid:true,
        name:"SOCSO Number",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        errorMessage: 'Invalid SOCSO Number format (Example: B3201002997A)'
    },
    {
        key:"hrdfNumber",
        columnCode: "hrdfNumber",
        options:[],
        icon:"",
        validation:{
            
            range:{
               
            maxValue:100
            }
        },
        isValid:true,
        name:"HRDF",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true,
        suffixIcon:'%'
    },
    {
        key:"zakatNumber",
        columnCode: "zakatNumber",
        options:[],
        icon:"",
        validation:{
            
            range:{
               
            maxLength: 6
            }
        },
        isValid:true,
        name:"Zakat Number",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"eisNumber",
        columnCode: "eisNumber",
        options:[],
        icon:"",
        validation:{
            regExp :'(^[[a-zA-Z]{1})([0-9]{10}[a-zA-Z]{1}$)',
        },
        isValid:true,
        name:"ESI No.",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true,
        errorMessage: 'Invalid EIS Number format (Example: B3201002997A)'
    },
    {
        key:"stateCode",
        columnCode: "stateCode",
        options:[],
        icon:"",
        validation:{
            regExp :'(^[[0-1]{1})([0-6]{1}$)',
        },
        isValid:true,                                                                                                                                                                                                                                                                                                                               
        name:"State Code",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"State code should be between 01-16",
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        errorMessage: 'Please enter a valid State Code'
    }
]

export const EMPLOYEE_FIELD = [
    {columnCode : "employee", uiVisible: true, name:"Employee", type:INPUT_TYPE.DROPDOWN, validation:[{"required":true}]},
    {
        columnCode : "year", 
        uiVisible: true,
        name:"Year",
        type:INPUT_TYPE.DROPDOWN,
        validation:[{"required":true}],
        conditionalHideShowFields:[
            {
                groupName : "visibility",
                value : false,
                fields : ["lifeStyleDeduction","domesticTourismExpenditure","netDepositSspns"],
                condition: [{key:"greaterThan", value : 2022}]
            }
        ]
    }
];

export const PREVIOUS_EMPLOYER_SECTION = [
    { columnCode : "lifeInsurance", uiVisible: true, name:"Accumulated Life Insurance", type:INPUT_TYPE.NUMBER },
    { columnCode : "totalAccumulatedFees", uiVisible: true, name:"Total accumulated zakat/fees/levy Paid", type:INPUT_TYPE.NUMBER },
    { columnCode : "employeeSocso", uiVisible: true, name:"Employee SOCSO", type:INPUT_TYPE.NUMBER, validation:[{"max":350}]},
    { columnCode : "employerSocso", uiVisible: true, name:"Employer SOCSO", type:INPUT_TYPE.NUMBER }
];

export const OPTIONAL_SECTION = [
    {
        columnCode : "basicSupport",
        uiVisible: true,
        name:"Basic supporting equipment for disabled self, spouse, child or parent",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"The purchase of any supporting equipment for one's own use, if he/she is a disabled person or for the use of his/her spouse, child or parent, who is a disabled person may be claimed but limited to a maximum of RM6,000.00 in a basis year. Basic supporting equipment includes haemodialysis machine, wheel chair, artificial leg and hearing aid but exclude optical lenses and spectacles.",
        validation:[{"max":6000}]
    },{
        columnCode : "retirementSchemeAnnuityContribution",
        uiVisible: true,
        name:"Contribution to Private Retirement Scheme and Payment of Deferred Annuity",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Deduction on contribution to Private Retirement Scheme approved by the Securities Commission under The Capital Markets and Services Act 2007 or payment of deferred annuity premium or both limited to RM3,000 per year (for 10 years from year assessment 2012 until year assessment 2021).",
        validation:[{"max":3000}]
    },{
        columnCode : "educationMedicalInsurancePremium",
        uiVisible: true,
        name:"Education and Medical Insurance Premium",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"A deduction not exceeding RM3,000.00 per year for insurance premiums in respect of education or medical benefits for an individual, husband, wife or child.",
        validation:[{"max":3000}]
    },{
        columnCode : "selfHigherEducationFees",
        uiVisible: true,
        name:"Higher Education Fees (Self)",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Payment of annual fee limited to RM7,000.00 is allowed as a deduction for any course of study in an institution or professional body in Malaysia recognized by the Government of Malaysia or approved by the Minister of Finance for the purpose of enhancing any skill or qualification: i. up to tertiary level (other than Masters and Doctorate) in law, accounting, Islamic finance, technical, vocational, industrial, scientific or technology; or ii. any course of study at Masters or Doctorate level.",
        validation:[{"max":7000}],
        dependentField:[{
            fieldId:"skillsImprovement",
            conditon:{"opr":"add","limit":7000},
            name:"5",
        }]
    },{
        columnCode : "skillsImprovement",
        uiVisible: true,
        name:"Skills improvement or self-improvement courses",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Deduction limit for course fees taken for skills upgrading and personal development is limited to RM2,000.",
        validation:[{"max":2000}],
        dependentField:[{
            fieldId:"selfHigherEducationFees",
            conditon:{"opr":"add","limit":7000},
            name:"4",
        }]
    },{
        columnCode : "houseLoanInterest",
        uiVisible: true,
        name:"Interest on Housing Loan",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"A deduction not exceeding RM10,000 for each basis year is given on housing loan interest for house purchased from developer or third party subject to the following conditions: i. the tax payer is a Malaysian citizen and a resident; ii. limited to one residential house; ill. has not derived any income; and iv. sale and purchase agreement is executed between 10 March 2009 and 31 December 2010. The tax deduction is given for 3 consecutive years from the first year the housing loan interest is paid.",
        validation:[{"max":10000}]
    },{
        columnCode : "parentsNeedsCareMedicalExpenses",
        uiVisible: true,
        name:"Medical Treatment, Special Needs or Carer Expenses of Parents",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Medical Treatment, Special Needs or Carer Expenses of Parents Medical treatment, special needs and carer for parents are limited to RM8,000.00 in a basis year. Medical expenses which qualify for deductions includes: i. medical care and treatment provided by a nursing home; and ii. dental treatment limited to tooth extraction, filling, scaling and cleaning but not including cosmetic dental treatment. The claim must be supported by a certified medical practitioner registered with the Malaysian Medical Council that the medical conditions of the parents require medical treatment or special needs or carer. The parents shall be resident in Malaysia. The medical treatment and care services are provided in Malaysia. In the case of carer, shall be proved by a written certification, receipt or copy of carer's work permit. 'Carer shall not include that individual, husband, wife or the child of that individual. iii. COVID-19 detection test fee: a. tests performed at a clinic or hospital b.purchase of self-test kits iv. Mental health examinations or consultations.",
        validation:[{"max":8000}]
    },{
        columnCode : "netDepositSspns",
        uiVisible: true,
        name:"Net Deposit in Skim Simpanan Pendidikan Nasional(SSPN)",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Net Deposit in Skim Simpanan Pendidikan Nasional (SSPN) Amount deposited in SSPN by an individual for his 9 children's education is deductible up to a maximum of RM8,000.00 per year. The deduction is limited to the net amount deposited in that basis year only.",
        validation:[{"max":8000}]
    },{
        columnCode : "alimonyPaymentToWife",
        uiVisible: true,
        name:"Payment of Alimony to Former Wife",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Payment of alimony to a former wife is deductible provided that the total deduction for wife (in paragraph 4.4.1 (b)) and alimony payment is limited to RM4,000.00 per year. Voluntary alimony payment to a former wife under a mutual agreement but without any formal agreement does not qualify as a deduction. Note: Payment of alimony to former wife is not allowed in the case where the employee claimed deduction for wife.",
        validation:[{"max":4000}]
    },{
        columnCode : "childCareKindergartensFeesDeduction",
        uiVisible: true,
        name:"Tax Deduction for Fees Paid to Child Care Centres and Kindergartens",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Individual taxpayers who enroll their children below 6 years of age, in child care centres registered with the Director General of Social Welfare under the Child Care Centre Act 1984 or kindergartens registered under the Education Act 1996.",
        validation:[{"max":3000}]
    },{
        columnCode : "lifeStyleDeduction",
        uiVisible: true,
        name:"Tax Deduction for Lifestyle",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"The lifestyle deduction is expanded to include: a.Purchase of printed daily newspaper; b.Purchase of smartphone or tablet; c.Internet subscription; d.Gymnasium membership fee.",
        validation:[{"max":2500}]
    },{
        columnCode : "feedingEquipmentPurchaseDeduction",
        uiVisible: true,
        name:"Tax Deduction for Purchase of Breastfeeding Equipment",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Individual taxpayers who enroll their children below 6 years of age, in child care centres registered with the Director General of Social Welfare under the Child Care Centre Act 1984 or kindergartens registered under the Education Act 1996.",
        validation:[{"max":1000}]
    },{
        columnCode : "domesticTourismExpenditure",
        uiVisible: true,
        name:"Domestic tourism expenditure",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Domestic tourism expenditure for:<br>(i) Accommodation fee at registered accommodation premises.<br>(ii) Entrance fee to tourist attractions.<br>(iii) Purchase of domestic travel packages through a registered licensed travel agent[Total i, ii, iii is limited to RM1000 per year]",
        validation:[{"max":1000}]
    },{
        columnCode : "electricVehicleChargingExpenditure",
        uiVisible: true,
        name:"Expenditure on payment of electric vehicle charging facilities",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Tax relief of up to RM2,500 is given to individuals for expenses related to:<br>i. The cost of installing an electric vehicle charger.<br>ii. Purchases include purchase on hire purchase of vehicle chargers.<br>iii. Vehicle charger rental. or<br>iv. Electric vehicle charging facility subscription fee.",
        validation:[{"max":2500}]
    },
]

export const MEDICAL_EXPENSES = [
    {
        columnCode : "seriousDiseasesMedicalExpenses",
        uiVisible: true,
        name:"Medical Expenses on Serious Diseases",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Medical expenses on serious diseases include the treatment of acquired immune deficiency syndrome (AIDS), Parkinson's disease, cancer, renal failure, leukaemia and other similar diseases. Other similar diseases such as heart attack, pulmonary hypertension, chronic liver disease, fulminant viral hepatitis, head trauma with neurological deficit, brain tumour or vascular malformation, major bums, major organ transplant or major amputation of limbs, fertility treatment for the taxpayer or the spouse. Amount expended on own self, husband/wife or child is deductible up to a maximum of RM8,000.00.",
        validation:[{"max":8000}],
        errName:"1",
        dependentField:[
            {
                fieldId:"fullMedicalExamination",
                conditon:{"opr":"add","limit":8000},
                name:"2",
            },{
                fieldId:"medicalExamination",
                conditon:{"opr":"add","limit":8000},
                name:"3",
            }
        ]
    },{
        columnCode : "fullMedicalExamination",
        uiVisible: true,
        name:"Full Medical examination",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Full medical examination, COVID-19 Detection test including Purchase of self-test kit or Mental health examination or Consultation on self, spouse or child [limited to RM1000 per year]",
        validation:[{"max":1000}],
        errName:"2",
        dependentField:[
            {
                fieldId:"seriousDiseasesMedicalExpenses",
                conditon:{"opr":"add","limit":8000},
                name:"1",
            },{
                fieldId:"medicalExamination",
                conditon:{"opr":"add","limit":8000},
                name:"3",
            }
        ]
    },{
        columnCode : "medicalExamination",
        uiVisible: true,
        name:"Complete medical examination from self, spouse or child",
        type:INPUT_TYPE.NUMBER,
        tooltipText:"Amount expended on own self, husband/wife or child for complete medical examination is deductible up to a maximum of RM1000.00. The total deduction for medical expenses on serious diseases (no. 4) and complete medical examination (no. 5) is limited to a maximum of RM8,000.00 a year.",
        validation:[{"max":1000}],
        errName:"3",
        dependentField:[
            {
                fieldId:"seriousDiseasesMedicalExpenses",
                conditon:{"opr":"add","limit":8000},
                name:"1",
            },{
                fieldId:"fullMedicalExamination",
                conditon:{"opr":"add","limit":8000},
                name:"2",
            }
        ]
    }
]